import { BasicLayout } from '@/components/layouts';
import permissionConst from '@/utils/const/permission';

export default {
  path: '/my-system',
  name: 'MySystem',
  component: BasicLayout,
  redirectToChild: true,
  meta: {
    title: '运维',
    icon: 'iconcalendar',
    authorities: permissionConst.manager,
  },
  children: [
    {
      path: '/my-system/error-log',
      name: 'MySystem.ErrorLog',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-system/ErrorLog.vue'),
      meta: {
        title: '错误日志',
        icon: 'icon-cuowurizhi',
      },
    },
    {
      path: '/my-system/task-log',
      name: 'MySystem.TaskLog',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-system/TaskLog.vue'),
      meta: {
        title: '推送日志',
        icon: 'icon-cuowurizhi',
      },
    },
  ],
};
